(function () {
    'use strict';

    angular.module("imApp").factory("customerPersonsService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomerPersons: function (parms) {
                return $ihttp.post({
                    method: 900,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
